import { AccessType, DataAccessSearchItem } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityDataAccessSearchRequest = {
	target?: Array<AccessType>;
	searchLimit?: number;
	queryString: string;
};

export type GetDataSecurityDataAccessSearchResponse = Record<string, Array<DataAccessSearchItem>>;

export const getDataSecurityDataAccessSearch =
	createGetEndpoint<GetDataSecurityDataAccessSearchRequest, GetDataSecurityDataAccessSearchResponse>(
		(request) => `/api/v3/salesforce/data-access/search?${getQueryString(request)}`
	);
